export default __webpack_public_path__ + "static/scratch-line-6ed2716630344ae13c39477866571e88.svg";